import { useState } from "react";
import { VEHICLES } from "@/lib/data";
import VehicleCard from "@/components/VehicleCard";
import EnquiryDialog from "@/components/EnquiryDialog";
import SectionHeading from "@/components/SectionHeading";

export default function Vehicles() {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [preselect, setPreselect] = useState("");

  const openEnquiry = (name = "") => {
    setPreselect(name);
    setEnquiryOpen(true);
  };

  return (
    <div data-testid="vehicles-page">
      {/* Header */}
      <section className="relative pt-32 pb-12 md:pt-40 md:pb-16 overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-60" />
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[500px] radial-glow-blue pointer-events-none" />
        <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.28em] text-red-500 mb-4 font-mono-brand">
            <span className="w-8 h-px bg-current" /> Our Fleet
          </div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-black tracking-tighter leading-[1.05] text-white">
            The T-Permit <span className="text-gradient-red">Vehicle Line-up</span>
          </h1>
          <p className="mt-6 text-lg text-slate-400 max-w-3xl leading-relaxed">
            Hand-picked commercial vehicles from India's most trusted OEMs — configured
            for airport duty, city taxi, tourist and fleet operations.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {VEHICLES.map((v, i) => (
              <VehicleCard key={v.slug} vehicle={v} index={i} onEnquire={openEnquiry} />
            ))}
          </div>
        </div>
      </section>

      <EnquiryDialog open={enquiryOpen} onOpenChange={setEnquiryOpen} defaultVehicle={preselect} />
    </div>
  );
}
